import {
  Icon,
  Tag,
  OverflowTooltip,
  useColorMode,
  useColorStyle,
  theme,
  Text,
  Flex,
} from '@tonic-one/react';
import { CloseIcon } from '@tonic-one/react-icons';
import { useTranslation } from 'react-i18next';
import IconButton from '@Components/IconButton';

interface FilterTagProps {
  field: string;
  value: string;
  onRemove: () => void;
  maxWidth?: string;
  onClick?: () => void;
  isClickable?: boolean;
}

const FilterTag = ({
  field,
  value,
  onRemove,
  maxWidth = '200px',
  onClick,
  isClickable = false,
}: FilterTagProps) => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const isEmpty = !value || value.trim() === '';
  const displayValue = isEmpty ? '' : value;
  const fullLabel = isEmpty
    ? `${field}: ${t('operations.euq.filter.emptySuffix')}`
    : `${field}: ${value}`;

  return (
    <Tag
      borderRadius="lg"
      columnGap="2x"
      _hover={
        isClickable
          ? {
              borderWidth: '1px',
              borderStyle: 'solid',
              borderColor: colorStyle.color.tertiary,
            }
          : undefined
      }
      transition="all 0.2s"
    >
      <Flex
        maxWidth={maxWidth}
        fontSize="sm"
        onClick={isClickable ? onClick : undefined}
        cursor={isClickable ? 'pointer' : 'default'}
        alignItems="center"
        gap="1x"
      >
        <Flex alignItems="center" gap="2x" width="100%">
          <Text color={colorStyle.color.secondary} whiteSpace="nowrap">
            {field}:
          </Text>
          <OverflowTooltip
            label={fullLabel}
            placement="top"
            nextToCursor={false}
            color={
              isEmpty && isClickable
                ? colorStyle.color.tertiary
                : colorStyle.color.primary
            }
            _hover={
              isClickable
                ? {
                    color: isEmpty
                      ? colorStyle.color.primary
                      : colorStyle.color.secondary,
                  }
                : undefined
            }
          >
            {displayValue}
          </OverflowTooltip>
        </Flex>
      </Flex>
      <IconButton onClick={onRemove}>
        <Icon
          as={CloseIcon}
          color={colorStyle.color.secondary}
          _hover={{
            color: (theme.colors as any)[colorStyle.color.primary],
          }}
          size="3x"
        />
      </IconButton>
    </Tag>
  );
};

export default FilterTag;
